import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import styled from 'styled-components'

export const EmptyStateContainerAndText = styled.div`
  text-align: center;
  padding: 64px 32px;
  color: #6c757d;
  font-size: 1rem;
  line-height: 24px;
`

export const EmptyStateTitle = styled.p`
  color: #424242;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 8px 0;
`

export const EmptyStateText = styled.p`
  color: #666;
  font-size: 1rem;
  margin: 0 0 24px 0;
`

export const ReusuableHeaderText = styled('h2')`
  color: #424242;
  font-size: 1rem;
  font-weight: 600;
`

export const ReusuableAddButton = styled(Button)`
  background: #fff;
  color: #424242;
  border: 1px solid #424242;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 1rem;
  font-weight: 600;
  text-transform: none;
  min-width: auto;

  &:hover {
    background: #0299e8;
    border: 1px solid #0299e8;
    color: #fff;
  }
`

export const SubTabAndButtonContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-top: 16px;
`

export const SoloSubTabText = styled('div')`
  color: #1f1f1f;
  font-size: 1rem;
  font-weight: 600;
  line-height: 20px;
`
//for headers like Company Information, Site Information, etc.
export const HeaderAndButtonContainerBorder = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  padding: 10px 20px;
`

export const IconButtonStyled = styled(IconButton)<{$isActive: boolean}>`
  width: 40px;
  height: 40px;
  color: ${(props) => (props.$isActive ? '#03a9fc' : '#666')};

  &:hover {
    background: #f8f9fa;
    border-color: #03a9fc;
    color: #03a9fc;
  }
`
export const BackButtonStyled = styled(Button)`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 40px;
  height: 40px;
  color: #666;

  &:hover {
    background: #f8f9fa;
    border-color: #03a9fc;
    color: #03a9fc;
  }
`

export const PageTitle = styled('h1')`
  color: #424242;
  font-family: 'Open Sans';
  font-size: 24px;
  font-weight: 700;
  margin: 0;
`

export const PageTitleContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 45px;
`
